module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-carousel",
    class: {
      'el-carousel--card': _vm.type === 'card'
    },
    on: {
      "mouseenter": function($event) {
        $event.stopPropagation();
        _vm.handleMouseEnter($event)
      },
      "mouseleave": function($event) {
        $event.stopPropagation();
        _vm.handleMouseLeave($event)
      }
    }
  }, [_c('div', {
    staticClass: "el-carousel__container",
    style: ({
      height: _vm.height
    })
  }, [_c('transition', {
    attrs: {
      "name": "carousel-arrow-left"
    }
  }, [(_vm.arrow !== 'never') ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.arrow === 'always' || _vm.hover) && _vm.left),
      expression: "(arrow === 'always' || hover) && left"
    }],
    staticClass: "el-carousel__arrow el-carousel__arrow--left",
    on: {
      "mouseenter": function($event) {
        _vm.handleButtonEnter('left')
      },
      "mouseleave": _vm.handleButtonLeave,
      "click": function($event) {
        $event.stopPropagation();
        _vm.throttledArrowClick(_vm.activeIndex - 1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "carousel-arrow-right"
    }
  }, [(_vm.arrow !== 'never') ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.arrow === 'always' || _vm.hover) && _vm.right),
      expression: "(arrow === 'always' || hover) && right"
    }],
    staticClass: "el-carousel__arrow el-carousel__arrow--right",
    on: {
      "mouseenter": function($event) {
        _vm.handleButtonEnter('right')
      },
      "mouseleave": _vm.handleButtonLeave,
      "click": function($event) {
        $event.stopPropagation();
        _vm.throttledArrowClick(_vm.activeIndex + 1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.indicatorPosition !== 'none') ? _c('ul', {
    staticClass: "el-carousel__indicators",
    class: {
      'el-carousel__indicators--labels': _vm.hasLabel, 'el-carousel__indicators--outside': _vm.indicatorPosition === 'outside' || _vm.type === 'card'
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "el-carousel__indicator",
      class: {
        'is-active': index === _vm.activeIndex
      },
      on: {
        "mouseenter": function($event) {
          _vm.throttledIndicatorHover(index)
        },
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleIndicatorClick(index)
        }
      }
    }, [_c('button', {
      staticClass: "el-carousel__button"
    }, [(_vm.hasLabel) ? _c('span', [_vm._v(_vm._s(item.label))]) : _vm._e()])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c315ed","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/index.vue
// module id = 929
// module chunks = 1